
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, class_type, list_type, option_type, anonRecord_type, union_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__startLoading, ToolId, SetId, FormState_get_empty, FormState__setValidationResponse_5219762A, StorageId__get_unwrap, BusinessUnitId__get_unwrap, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../Shared/Shared.js";
import { Storage_$reflection } from "../Shared/Storage.js";
import { UpdateAssignedBusinessUnitDto, BusinessUnitOverviewDto_$reflection } from "../Shared/BusinessUnit.js";
import { find, ofArray, tryFind, map as map_1, filter, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createObj, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../Components/Toast.js";
import { updateBusinessUnitCmd } from "../Requests/Set.js";
import { parse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_updateBusinessUnitCmd } from "../Requests/Tool.js";
import { getResponsibleBusinessUnits } from "../Requests/BusinessUnit.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "../Components/Select.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { BusinessUnitSelect } from "./BusinessUnitSelect.js";
import { ErrorAlert } from "../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../Components/Dialog.js";
import { Skeleton } from "../Components/Skeleton.js";
import { TextButton } from "../Components/Button.js";

export class RequestTargetId extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ToolId", "SetId"];
    }
}

export function RequestTargetId_$reflection() {
    return union_type("Widgets.ChangeBusinessUnitDialog.RequestTargetId", [], RequestTargetId, () => [[["Item", string_type]], [["Item", string_type]]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OnSave", "SavedResponse", "SetSelectedStorage", "SetBusinessUnit", "BusinessUnitsFetched", "UpdateStorageOptions", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.ChangeBusinessUnitDialog.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(OnClose, OnSuccessCallback, RequestTargetId, AllStorage, SelectedBusinessUnitId, BusinessUnits, CurrentStorage, StorageOptions, FormState) {
        super();
        this.OnClose = OnClose;
        this.OnSuccessCallback = OnSuccessCallback;
        this.RequestTargetId = RequestTargetId;
        this.AllStorage = AllStorage;
        this.SelectedBusinessUnitId = SelectedBusinessUnitId;
        this.BusinessUnits = BusinessUnits;
        this.CurrentStorage = CurrentStorage;
        this.StorageOptions = StorageOptions;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Widgets.ChangeBusinessUnitDialog.State", [], State, () => [["OnClose", lambda_type(unit_type, unit_type)], ["OnSuccessCallback", lambda_type(unit_type, unit_type)], ["RequestTargetId", RequestTargetId_$reflection()], ["AllStorage", list_type(Storage_$reflection())], ["SelectedBusinessUnitId", option_type(string_type)], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["CurrentStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["StorageOptions", list_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["FormState", FormState_$reflection()]]);
}

function update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, state.BusinessUnits, msg.fields[0], state.StorageOptions, state.FormState), singleton((dispatch) => {
                dispatch(new Msg(5, []));
            })];
        case 3:
            return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, map((value_2) => value_2.value.Id, msg.fields[0]), state.BusinessUnits, state.CurrentStorage, state.StorageOptions, state.FormState), singleton((dispatch_1) => {
                dispatch_1(new Msg(5, []));
            })];
        case 4:
            return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, new RequestedValue$1(1, [msg.fields[0]]), state.CurrentStorage, state.StorageOptions, state.FormState), singleton((dispatch_2) => {
                dispatch_2(new Msg(5, []));
            })];
        case 5: {
            const updatedOptions = filter((storage_1) => {
                const matchValue_2 = storage_1.value.BusinessUnitId;
                const matchValue_3 = state.SelectedBusinessUnitId;
                if (matchValue_2 == null) {
                    if (matchValue_3 != null) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else if (matchValue_3 == null) {
                    return false;
                }
                else {
                    const businessUnitId = matchValue_3;
                    const storageBusinessUnitId = matchValue_2;
                    return BusinessUnitId__get_unwrap(storageBusinessUnitId) === businessUnitId;
                }
            }, map_1((storage) => ({
                label: storage.Name,
                value: storage,
            }), state.AllStorage));
            return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, state.BusinessUnits, tryFind((option_1) => {
                const matchValue_5 = state.CurrentStorage;
                if (matchValue_5 == null) {
                    return false;
                }
                else {
                    return equals(matchValue_5.value.Id, option_1.value.Id);
                }
            }, updatedOptions), filter((storage_3) => {
                const matchValue_6 = state.CurrentStorage;
                if (matchValue_6 == null) {
                    return true;
                }
                else {
                    const currentStorage_1 = matchValue_6;
                    return StorageId__get_unwrap(storage_3.value.Id) !== StorageId__get_unwrap(currentStorage_1.value.Id);
                }
            }, updatedOptions), state.FormState), Cmd_none()];
        }
        case 1: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, state.BusinessUnits, state.CurrentStorage, state.StorageOptions, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, state.BusinessUnits, state.CurrentStorage, state.StorageOptions, FormState_get_empty()), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.OnSuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 6:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.CurrentStorage;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new UpdateAssignedBusinessUnitDto(state.SelectedBusinessUnitId, StorageId__get_unwrap(matchValue.value.Id));
                let cmd;
                const matchValue_1 = state.RequestTargetId;
                cmd = ((matchValue_1.tag === 1) ? updateBusinessUnitCmd(new SetId(parse(matchValue_1.fields[0])), dto, (Item_4) => (new Msg(1, [Item_4])), (Item_5) => (new Msg(6, [Item_5]))) : Cmd_updateBusinessUnitCmd(new ToolId(parse(matchValue_1.fields[0])), dto, (Item_1) => (new Msg(1, [Item_1])), (Item_2) => (new Msg(6, [Item_2]))));
                return [new State(state.OnClose, state.OnSuccessCallback, state.RequestTargetId, state.AllStorage, state.SelectedBusinessUnitId, state.BusinessUnits, state.CurrentStorage, state.StorageOptions, FormState__startLoading(state.FormState)), cmd];
            }
        }
    }
}

function init(onClose, onSuccessCallback, storageId, selectedBusinessUnitId, storages, requestTargetId) {
    const currentStorage = find((storage) => (StorageId__get_unwrap(storage.Id) === storageId), storages);
    return [new State(onClose, onSuccessCallback, requestTargetId, storages, selectedBusinessUnitId, new RequestedValue$1(0, []), {
        label: currentStorage.Name,
        value: currentStorage,
    }, filter((storage_3) => (StorageId__get_unwrap(storage_3.value.Id) !== storageId), filter((storage_2) => {
        const matchValue = storage_2.value.BusinessUnitId;
        if (matchValue == null) {
            if (selectedBusinessUnitId != null) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (selectedBusinessUnitId == null) {
            return false;
        }
        else {
            const businessUnitId = selectedBusinessUnitId;
            const storageBusinessUnitId = matchValue;
            return BusinessUnitId__get_unwrap(storageBusinessUnitId) === businessUnitId;
        }
    }, map_1((storage_1) => ({
        label: storage_1.Name,
        value: storage_1,
    }), storages))), FormState_get_empty()), Cmd_batch(singleton(getResponsibleBusinessUnits((Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(6, [Item_1])))))];
}

function StorageSelect(props) {
    const t = useTranslation()[0];
    return createElement(Select, {
        ComponentState: props.ComponentState,
        IsClearable: false,
        Label: t("general.storage"),
        NoOptionsMessage: "",
        OnChange: (option) => {
            props.Dispatch(new Msg(2, [option]));
        },
        Options: props.StorageOptions,
        PlaceholderKey: "",
        TestId: "business-unit-change-dialog-storage-test-id",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
        Value: unwrap(props.SelectedStorage),
    });
}

function DialogBody(props) {
    let elems;
    const patternInput = useTranslation();
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["id", "change-business-unit-dialog-body"], ["data-test-id", "change-business-unit-dialog-body"], ["className", join(" ", ["grid", "gap-5"])], (elems = toList(delay(() => append(singleton_1(createElement(BusinessUnitSelect, {
        BusinessUnits: props.BusinessUnits,
        FormState: props.FormState,
        OnChange: (value_5) => {
            props.Dispatch(new Msg(3, [value_5]));
        },
        SelectedBusinessUnitId: unwrap(props.SelectedBusinessUnitId),
    })), delay(() => append(singleton_1(createElement(StorageSelect, {
        ComponentState: componentState,
        Dispatch: props.Dispatch,
        FormState: props.FormState,
        SelectedStorage: unwrap(props.SelectedStorage),
        StorageOptions: props.StorageOptions,
    })), delay(() => {
        const matchValue = FormState__getValidation(props.FormState, patternInput[0], "global");
        if (matchValue == null) {
            return empty();
        }
        else {
            return singleton_1(createElement(ErrorAlert, {
                Label: matchValue,
            }));
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ChangeBusinessUnitDialog(props) {
    let elems, Title, Label_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.OnClose, props.OnSuccessCallback, props.StorageId, props.SelectedBusinessUnitId, props.Storages, props.RequestTargetId), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton((elems = [createElement(Dialog, (Title = t("business_units.change_dialog.title"), {
        Body: toList(delay(() => {
            const matchValue = state_1.BusinessUnits;
            return (matchValue.tag === 0) ? singleton_1(createElement(Skeleton, {
                Variant: "normal",
            })) : singleton_1(createElement(DialogBody, {
                BusinessUnits: matchValue.fields[0],
                Dispatch: dispatch,
                FormState: state_1.FormState,
                SelectedBusinessUnitId: unwrap(state_1.SelectedBusinessUnitId),
                SelectedStorage: unwrap(state_1.CurrentStorage),
                StorageOptions: state_1.StorageOptions,
                Storages: props.Storages,
            }));
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-change-business-unit-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_1 = t("general.save"), {
            ComponentState: (componentState === "disabled") ? componentState : ((state_1.CurrentStorage != null) ? componentState : "disabled"),
            Label: Label_1,
            OnClick: () => {
                dispatch(new Msg(0, []));
            },
            TestId: "save-change-business-unit-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

